import { NetworkStatus, useQuery } from '@apollo/client';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import AllEmployees from 'components/Tables/AllEmployees';
import { GET_USERS_QUERY, GetUsersQueryResponse, GetUsersQueryVariables } from 'graphql/query/user';
import { useState } from 'react';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const AllEmployeesPage = () => {
  const [filters, setFilters] = useState<Record<string, any>>({});

  const {
    data: users,
    refetch: refetchUsers,
    networkStatus,
  } = useQuery<GetUsersQueryResponse, GetUsersQueryVariables>(GET_USERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      filter: {
        year: getSelectedObjectiveGoalsYear(),
      },
    },
  });

  const loadingUsers =
    networkStatus === NetworkStatus.loading || networkStatus === NetworkStatus.setVariables;

  const applyFilters = (newFilters: any) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      ...newFilters,
    }));

    refetchUsers({
      filter: {
        ...filters,
        ...newFilters,
      },
    });
  };
  return (
    <Navbar
      title={`Employees - ${getSelectedObjectiveGoalsYear()}`}
      searchInputConfig={{
        enable: true,
        name: 'Search',
        placeholder: 'Search employee',
        handleChange: searchFilter =>
          applyFilters({
            ...filters,
            searchTerm: !!searchFilter ? searchFilter : null,
          }),
      }}
    >
      {loadingUsers ? (
        <LoadingIndicator />
      ) : (
        <AllEmployees title="Employees" rows={users?.getUsers ?? []} />
      )}
    </Navbar>
  );
};

export default AllEmployeesPage;
